import '../styles/mission.css'
import { useInView } from 'react-intersection-observer'

function Mission(props) {

  const [ref, inView]  = useInView
  ({threshold:0.2,
  });
  return (
     <section ref={ref} className="u-align-center u-clearfix u-section-5" id="Mision">
      <div className="u-clearfix u-sheet u-valign-middle u-sheet-1">
        <h3 className="u-text u-text-palette-2-base u-text-1"> {props.t("seccion5_1")}</h3>
        <p className="u-text u-text-palette-2-base u-text-2">{props.t("seccion5_2")} </p>
      </div>
    </section>
  );
}

export default Mission;